<template>
  <div class="rt-icon" @click="click">
    <svg
      :width="size"
      :height="size"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      aria-hidden="true"
    >
      <use :xlink:href="'#' + name" :fill="color" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'RtIcon',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    name: {
      type: String
    },
    size: {
      type: [Number, String],
      default: 14
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click(event) {
      if (!this.disabled) this.$emit('click', event);
    }
  }
};
</script>
<style lang="less">
.rt-icon {
  display: inline-block;
  svg {
    display: inline-block;
    position: relative;
    vertical-align: top;
  }
}
</style>



// WEBPACK FOOTER //
// rtIcon.vue?1559c937